export default __webpack_public_path__ + "static/media/ff1df1b70a31bd8d64634bd882d1f2781581594351202.6bc33cf6.webp";